import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, Grid, Typography, Avatar, Button } from '@material-ui/core';

import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import CardActionArea from '@material-ui/core/CardActionArea';
import { getLastTerrace } from '../services/http';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        height: 56,
        width: 56
    },
    number: {
        color: theme.palette.primary.main
    },
    icon: {
        height: 32,
        width: 32
    },
    labelAction: {
        width: '100%',
        textAlign: 'center'
    },
    footer: {
        padding: 10,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center'
    }
}));

const TotalAddedCard = ({ className, rest, raised }) => {
    const classes = useStyles();
    const [data, setData] = useState({});

    useEffect(() => {
        getLastTerrace()
            .then(res => setData(res))
            .catch(err => alert(err));
    }, []);

    return (
        <CardActionArea component={RouterLink} to={'/new-terrace/create'}>
            <Card {...rest} raised={raised} className={clsx(classes.root, className)}>
                <CardContent>
                    <Grid container direction="column" spacing={2}>
                        <Grid item container justify="space-between">
                            <Grid item>
                                <Typography
                                    className={classes.title}
                                    color="textSecondary"
                                    gutterBottom
                                    variant="body1">
                                    Terrases enregistrées
                                </Typography>
                                <Typography variant="h3" className={classes.number} gutterBottom>
                                    {data.number ?? 0}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Avatar className={classes.avatar}>
                                    <NaturePeopleIcon className={classes.icon} />
                                </Avatar>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2">
                                Dernière terrasee créée <strong>{data.last?.label}</strong> le{' '}
                                <strong>{data.last?.date}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <div className={classes.footer}>
                    <Button className={classes.labelAction} color="primary">
                        Créer une nouvelle terrasse
                    </Button>
                </div>
            </Card>
        </CardActionArea>
    );
};

export default TotalAddedCard;
